import { ReactComponent as ProfileIcon } from "./profile.svg";

import Icon from "../Icon";

export default ProfileIcon as any as Icon;
